<template>
  <v-row>
    <v-col class="py-1" :class="{ 'pt-0': first }">
      <v-btn
        :outlined="selectedTime !== value"
        @click="show"
        block
        class="available-time-btn"
        color="primary"
        large
      >
        {{ parsedTime }}
      </v-btn>
    </v-col>
  </v-row>
</template>
<style>
.available-time-btn {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<script>
import moment from 'moment';

import { TIME_FORMAT } from '../constants/moment';

export default {
  name: 'AvailableTime',
  data: () => ({
    selected: false,
  }),
  methods: {
    show() {
      this.$store.commit('updateAppointment', { time: this.value });
    },
  },
  props: { value: Number, first: Boolean },
  computed: {
    selectedTime() {
      return this.$store.state.appointment.time;
    },
    parsedTime() {
      return moment(this.value).format(TIME_FORMAT);
    },
  },
};
</script>
